export default "__VITE_ASSET__C_mjQlhZ__"